export const headerData = {
    mobileMenuOpen: false,
    desktopDropdownOpen: false,
    currentDropdown: null,
    menuStack: [],
    menuTree: [],
    menuMap: new Map(),
    currentMenu: { id: "main", title: "Menu główne" },

    init() {
        // console.log('Initializing header with menu:', this.menuTree);
        this.buildMenuMap(this.menuTree);

        // Event listeners
        window.addEventListener("click", (e) => {
            if (!e.target.closest(".desktop-dropdown")) {
                this.desktopDropdownOpen = false;
                this.currentDropdown = null;
            }
        });
    },

    toggleMobileMenu() {
        this.mobileMenuOpen = !this.mobileMenuOpen;
        // Reset menu state when opening
        if (this.mobileMenuOpen) {
            this.currentMenu = { id: "main", title: "Menu główne" };
            this.menuStack = [];
        }
    },

    buildMenuMap(items, parent = null) {
        if (!items || !Array.isArray(items)) return;
        items.forEach(item => {
            if (item && item.id) {
                this.menuMap.set(item.id, { ...item, parent });
                if (item.children && Array.isArray(item.children) && item.children.length) {
                    this.buildMenuMap(item.children, item);
                }
            }
        });
    },

    goToMenu(menu) {
        // console.log('Going to menu:', menu);
        this.menuStack.push({...this.currentMenu});
        this.currentMenu = menu;
    },

    goBack() {
        // console.log('Going back, stack:', this.menuStack);
        if (this.menuStack.length > 0) {
            this.currentMenu = this.menuStack.pop();
        } else {
            this.currentMenu = { id: "main", title: "Menu główne" };
        }
    },

    getCurrentMenuItems() {
        // console.log('Getting items for menu:', this.currentMenu);
        if (this.currentMenu.id === "main") return [];
        if (this.currentMenu.id === "categories") return this.menuTree;
        const menuItem = this.menuMap.get(this.currentMenu.id);
        return menuItem ? (menuItem.children || []) : [];
    }
};